import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/tariff'

const initialState = () => ({
    legs: {
        data: [],
        pagination: {}
    },
    tariffs: {
        data: [],
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        legs: state => state.legs.data,
        pagination: state => state.legs.pagination,
        tariffs: state => state.tariffs.data,
    },
    actions: {
        /**
         * @param {{params: {}}} data
         * @returns {Promise<*>}
         */
        listAllTariffs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listAllTariffs(data)

                commit(mutationTypes.SET_TARIFFS, response.data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{tariffId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listLegs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listLegs(data)
                const legs = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_TARIFF_LEGS, legs)
                return legs
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetLegs: ({commit}) => commit(mutationTypes.RESET_TARIFF_LEGS),
        resetTariffs: ({commit}) => commit(mutationTypes.RESET_TARIFFS)
    },
    mutations: {
        [mutationTypes.RESET_TARIFF_LEGS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_TARIFF_LEGS]: (state, data) => state.legs = data,
        [mutationTypes.RESET_TARIFFS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_TARIFFS]: (state, data) => state.tariffs = data
    }
}
